const faq = {
  getlist: 'faq/getlist-by-admin',
  getAll: 'faq/getall',
  add: 'faq/add',
  update: 'faq/update',
  remove: 'faq/remove',
  get: 'faq/getByAdmin',
  clearcache: 'faq/clear-cache',
}
export default faq
